import React from 'react';

const Feature = () => {
    return (
        <div className='mb-20  '>
            <div class="hero max-h-screen ">
                <div class="hero-content flex-col lg:flex-row lg:gap-10 gap-0">
                    <img src="https://www.gamingscan.com/wp-content/uploads/2020/10/pc-component-compatibility.jpg" class="max-w-sm rounded-lg shadow-2xl" alt='..' />
                    <div>
                        <h1 class="text-5xl font-bold">Featured products at one place!</h1>
                        <p class="py-6">Best Tech is passionate about technology and driven by innovation. We dream, we dare and we strive to create an effortless and joyful digital life for everyone. </p>
                        <button class="btn btn-primary">Get Started</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Feature;